import React, { useEffect } from "react";
import { Button } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { useExternalBillModel } from "../externalBillModel";
import { globalPrompt } from "@/components/message";
import useNavModel from "@/model/navModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";

export const DataBox = () => {
    const { selectedRowKeys, selectedRow, descTotal, rowsDescTotal, exportExternalBill,
        approvalPrintVisible, setApprovalPrintVisible,
        pickCarPrintVisible, setPickCarPrintVisible,
        completedPrintVisible, setCompletedPrintVisible } = useExternalBillModel();
    const { selectedNavId, replaceNav, findNav } = useNavModel();

    const onLook = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let supplierEditKey = "20-3";
        replaceNav(
            selectedNavId,
            supplierEditKey,
            { id: selectedRow.id as string, mode: "look", },
            true
        );
    }
    const pickCarPrint = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条打印，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        setPickCarPrintVisible(true)

    }
    const completedPrint = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条打印，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        setCompletedPrintVisible(true)
    }
    const approvalPrint = () => {
        if (selectedRowKeys.length < 1) {
            globalPrompt("message", { text: "请选择单据进行打印！", type: "warning" });
            return;
        }
        setApprovalPrintVisible(true)

    }
    const action =
        <>
            <YhAuth resCode={ResourceAuthEnum.VRM2_EXTERNALREPAIR_DETIAL}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={onLook}
                >查看</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.VRM2_EXTERNALREPAIR_EXPORT}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={() => { exportExternalBill() }}
                >导出</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.VRM2_EXTERNALREPAIR_SPPRINT}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={() => { approvalPrint() }}
                >打印审批单</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.VRM2_EXTERNALREPAIR_JCPRINT}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={() => { pickCarPrint() }}
                >打印接车单</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.VRM2_EXTERNALREPAIR_JGPRINT}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={() => { completedPrint() }}
                >打印竣工单</Button>
            </YhAuth>
        </>;

    return (
        <YhBox action={action} style={{ height: 'calc(100vh - 180px)' }}>
            <DataTable />
        </YhBox>
    )
}